import { Box, Typography } from "@mui/material"
import { DeleteOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { useWarehouseShelvingFilter } from "../hooks/useWarehouseShelvingFilter"

import { Button } from "@/components/common/Button"
import { FilterChip } from "@/components/common/Filters"

export const WarehouseShelvingFilterChips: FC = () => {
  const {
    utils: { clearFilterAll, clearFilterField },
    getFilterChips,
    clearBinStatus,
  } = useWarehouseShelvingFilter()

  const filterChips = getFilterChips()

  if (!filterChips) {
    return null
  }

  return (
    <Box className='mb-4 flex flex-wrap items-center gap-2' data-testid='warehouse-shelving-filter-chips'>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      {filterChips.labelColdStorage && (
        <FilterChip
          key='coldStorage'
          label={`Type: ${filterChips.labelColdStorage}`}
          onDelete={() => clearFilterField("coldStorage")}
          testId='warehouse-shelving-cold-storage-filter-chip'
        />
      )}
      {filterChips.labelH3ColdStorage && (
        <FilterChip
          key='h3ColdStorage'
          label={`Type: ${filterChips.labelH3ColdStorage}`}
          onDelete={() => clearFilterField("h3ColdStorage")}
          testId='warehouse-shelving-h3-cold-storage-filter-chip'
        />
      )}
      {filterChips.labelDeep && (
        <FilterChip
          key='deep'
          label={`Type: ${filterChips.labelDeep}`}
          onDelete={() => clearFilterField("deep")}
          testId='warehouse-shelving-deep-filter-chip'
        />
      )}
      {filterChips.binSize &&
        Array.isArray(filterChips.binSize) &&
        filterChips.binSize.length > 0 &&
        filterChips.binSize.map((item) => (
          <FilterChip
            key={`binSize-${item.name}`}
            label={`Bin Size: ${item.label}`}
            onDelete={() => clearFilterField("binSize", item.name)}
            testId='warehouse-shelving-bin-size-filter-chip'
          />
        ))}
      {filterChips.labelBinStatus && (
        <FilterChip
          key='binStatus'
          label={`Bin Status: ${filterChips.labelBinStatus}`}
          onDelete={() => clearBinStatus()}
          testId='warehouse-shelving-bin-status-filter-chip'
        />
      )}
      {filterChips.labelUndefined && (
        <FilterChip
          key='hasUndefined'
          label={filterChips.labelUndefined}
          onDelete={() => clearFilterField("isUndefined")}
          testId='warehouse-shelving-has-undefined-filter-chip'
        />
      )}

      <Button
        variant='primary'
        size='small'
        appearance='text'
        tabIndex={-1}
        startIcon={<DeleteOutlined fontSize='small' />}
        onClick={clearFilterAll}
      >
        Clear All
      </Button>
    </Box>
  )
}
